import { debounce } from 'lodash';
import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Search, SearchResultData } from 'semantic-ui-react';

interface DataSearchBoxProps {
	onSearchChange: (value: string) => void;
}

export const DataSearchBox: React.FC<DataSearchBoxProps> = ({ onSearchChange }) => {
	const { t } = useTranslation();

	const handleSearchChange = (event: SyntheticEvent<HTMLElement>, { value }: SearchResultData) => {
		onSearchChange(value ?? '');
	};

	return (
		<Search
			style={{ width: '100%' }}
			className="attached"
			category
			open={false}
			showNoResults={true}
			onSearchChange={debounce(handleSearchChange, 500, { leading: true })}
			input={<Input style={{ width: '100%' }} placeholder={t('search')} icon="search" iconPosition="left" />}
		/>
	);
};
